import { getTickets } from "@/http/ticketsApi";
import { getTicketsQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetTicketsQuery = () => {
  return useQuery({
    queryKey: getTicketsQueryKey(),
    queryFn: () => getTickets(),
    select: (response) => response.data.data,
  });
};
